import { getRoot } from "mobx-state-tree";

export const timeSlotsFactoryViews = self => ({
  get root() {
    return getRoot(self);
  },
  
});
